/// <reference types="@capacitor/cli" />
export {};
//# sourceMappingURL=definitions.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@capacitor/push-notifications/dist/esm/definitions.js
// module id = 115
// module chunks = 1